import ApiSDKError from './ApiSDKError';

export default class CommandNotFoundError extends ApiSDKError {
    constructor(message: string) {
        super(`Command ${message} not found.`);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = 'CommandNotFoundError';
    }
}
